export const CAPABILITY_CREDENTIAL_UPDATE = "CredentialUpdate" as const;
export const CAPABILITY_SUPPRESS_QR = "SuppressQr" as const;
export const CAPABILITY_REAL_TIME_SYNC_CHECK = "RealTimeSyncCheck" as const;

export function supportsCredentialUpdate(dto: {
  capabilities?: string[] | null;
}): boolean {
  return dto.capabilities?.includes(CAPABILITY_CREDENTIAL_UPDATE) ?? false;
}

export function suppressesQr(dto: { capabilities?: string[] | null }): boolean {
  return dto.capabilities?.includes(CAPABILITY_SUPPRESS_QR) ?? false;
}

export function supportsRealTimeSyncCheck(dto: {
  capabilities?: string[] | null;
}): boolean {
  return dto.capabilities?.includes(CAPABILITY_REAL_TIME_SYNC_CHECK) ?? false;
}
